import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getTooltipsActive} from "~/stateGetter";

const connectTooltip = connect(
    (state) =>  {
        return {
            active: getTooltipsActive(state)
        }
    },
    (dispatch) => ({
        
    }),
    (state, dispatch, props, ) => {
        return {
            ...state,
            ...props
        }
    }
);

export default connectTooltip;